import type { DashBoardType } from '@src/store/dashboards/@types';

export const dashboardItems: DashBoardType[] = [
    {
        id: 0,
        widgetCollectionTypeID: 0,
        dataSourceTypeID: 0,
        name: 'Temp 1',
        cellsX: 3,
        cellsY: 3,
        isHidden: true,
    },
    {
        id: 1,
        widgetCollectionTypeID: 0,
        dataSourceTypeID: 0,
        name: 'Temp 2',
        cellsX: 0,
        cellsY: 0,
        isHidden: true,
    },
    {
        id: 2,
        widgetCollectionTypeID: 0,
        dataSourceTypeID: 0,
        name: 'Temp 3',
        cellsX: 3,
        cellsY: 4,
        isHidden: true,
    },
];
